import {ApiTags} from '@nestjs/swagger';
import { Controller, Post, Body, Req } from '@nestjs/common';
import {ApplicationExceptionHandler} from '@gtpl/shared-utils/error-messages';
import { CommonResponse } from '@gtpl/shared-models/masters';
import { GradingMonitoringDTO } from '../dto/grading-monitoring.dto';
import { GradingMonitoring} from '../entities/grading-monitoring.entity';
import { GradingMonitoringService } from './grading-monitoring.service';
import { AllGradingMonitoringResponseModel, GradingMonitoringResponseModel } from '@gtpl/shared-models/production-management';
import { GradeInventoryIdRequest } from '../dto/grad-inv-id-req';


@ApiTags('grading-monitoring')
@Controller('grading-monitoring')
export class GradingMonitoringController {
    constructor(
        private service: GradingMonitoringService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler
    ){}
    @Post('/createGradingMonitoring')
    async createGradingMonitoring(@Body() dto: GradingMonitoringDTO, isUpdate: boolean = false): Promise<GradingMonitoringResponseModel>{
    try{
        return await this.service.createGradingMonitoring(dto, false);        
         } catch(error){
             return this.applicationExceptionHandler.returnException(GradingMonitoringResponseModel, error);
        }
    } 

    @Post('/getSamplesInfoByGrdInvId')
    async getSamplesInfoByGrdInvId(@Body() req:GradeInventoryIdRequest): Promise<AllGradingMonitoringResponseModel> {
        try {
            return await this.service.getSamplesInfoByGrdInvId(req)
        } catch (error) {
            return this.applicationExceptionHandler.returnException(AllGradingMonitoringResponseModel, error);
        }
    }

    @Post('/getAllGradeMonitoring')
    async getAllGradeMonitoring(): Promise<AllGradingMonitoringResponseModel> {
        try {
            return await this.service.getAllGradeMonitoring()
        } catch (error) {
            return this.applicationExceptionHandler.returnException(AllGradingMonitoringResponseModel, error);
        }
    }

}
